/* Dark logo band directly under the hero. Confirmed partners loop in a
   masked marquee; monochrome white treatment keeps the brands uniform. */

const OPTICAL_HEIGHT = { DNB: 26, Equinor: 46, DNV: 36, Kongsberg: 15, Telenor: 30 };

export default function PartnerStrip({ partners }) {
  const scrollTo = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const confirmed = (partners || []).filter((p) => p.confirmed);
  if (confirmed.length === 0) return null;

  const loop = [...confirmed, ...confirmed, ...confirmed];

  return (
    <section data-testid="partner-strip" className="logo-strip section-dark">
      <div className="hero-wide py-8 md:py-9 flex flex-col md:flex-row md:items-center gap-6 md:gap-12">
        <span className="strip-label shrink-0" data-testid="partner-strip-label">
          Partners
        </span>

        <div className="logo-marquee flex-1 min-w-0" data-testid="partner-strip-marquee">
          <div className="logo-track">
            {[0, 1].map((half) => (
              <div className="logo-group" key={half} aria-hidden={half === 1}>
                {loop.map((p, i) => (
                  <div
                    key={`${half}-${i}`}
                    className="logo-item"
                    data-testid={half === 0 ? `partner-strip-logo-${i}` : undefined}
                  >
                    {p.logo_url ? (
                      <img
                        src={p.logo_url}
                        alt={p.name}
                        style={{ height: OPTICAL_HEIGHT[p.name] || 30 }}
                        loading="lazy"
                      />
                    ) : (
                      <span className="sponsor-name">{p.name}</span>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        <a
          href="#partner-inquiry"
          onClick={scrollTo("partner-inquiry")}
          className="sponsor-link shrink-0 w-fit"
          data-testid="partner-strip-cta"
        >
          Partner with us
          <span aria-hidden>→</span>
        </a>
      </div>
    </section>
  );
}
